import gql from "graphql-tag";

export const CREATE_UPDATE_CUSTOMER = gql`
mutation upsertCustomer($customer:[Customers_insert_input!]!, $updateColumns: [Customers_update_column!]!,
                        $customerAddress:CustomerAddresses_set_input, $customerId: uuid!,
                        $credit:[CustomerCredit_insert_input!]!, $updateColumnsCredit: [CustomerCredit_update_column!]!) {
  insert_Customers(objects: $customer, on_conflict: {constraint: Customers_pkey, update_columns: $updateColumns}){
    returning{id}
  } 
  update_CustomerAddresses(where: {customerId: {_eq: $customerId}}, _set: $customerAddress){
   affected_rows
  }
  insert_CustomerCredit(objects: $credit, on_conflict: {constraint: CustomerCredit_pkey, update_columns: $updateColumnsCredit}){
    returning{id}
  },  
}`

export const SAVE_OPENING_BALANCE = gql`
mutation ($creditDebit:[CreditDebit_insert_input!]!, $updateColumns: [CreditDebit_update_column!]!) {
  insert_CreditDebit(objects: $creditDebit, on_conflict: {constraint: CreditDebit_pkey, update_columns: $updateColumns}){
   affected_rows
  }
}`